// import React from 'react'
// import { Button } from 'primereact/button';
// // import { Dialog } from 'primereact/dialog';
// import { base_url, check_api, Subscribe_api } from '../Services/Apis';
// import axios from 'axios'
// import {useNavigate} from 'react-router-dom'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import 'react-toastify/dist/ReactToastify.css';


// const ConfirmationModal = ({visible,handleCloseModal,number,pack}) => {

//     const params = new URLSearchParams(window.location.search)
//       const extId = params.get('ext_ref')

//       const navigate = useNavigate()

//     const handleSubmit=async()=>{
//         try{

//             const data ={
//         "msisdn":number,
//         "tid":extId,
//         "pack":pack,
//         "mode":"WAP_API",
//         "service":"FunnyBone"
//     }

//     const response = await axios.get(`${check_api}?tid=${extId}`);
//     console.log(response,'response of check api --------')


//     // const urlHitResponse = await axios.get(response.data);
//     // console.log(urlHitResponse,'response url hit response---------------')


//     console.log(response.data);
//     if(response.data.ft == 1000){
//         const res = await axios.post(`${Subscribe_api}`,data)
//         console.log(res.data)
//         navigate(`/home?ext_ref=${extId}`)
//     }
//     else{
//         toast.error("UnAuthorized!!")
//         handleCloseModal();
//     }

    
// }
//         catch(err){
//             console.log(err)
//             toast.error(err.response.data)
//             navigate('/subscribe')
//         }
//     }

//     const footerContent = (
//         <div className='flex gap-2 justify-center'>
//         <button className='p-2  text-white text-lg font-bold bg-[#495057] rounded-md px-4' onClick={()=>handleCloseModal()}>Cancel</button>
//         <button className='p-2 text-white text-lg font-bold bg-[#00c9a7] rounded-md px-4' onClick={handleSubmit}>Confirm</button>    
//         </div>
//     );

//     return (
//         <div className="card flex justify-content-center">
//             {/* <Button label="Show" icon="pi pi-external-link" onClick={() => setVisible(true)} /> */}
//             <div visible={visible} modal  footer={footerContent} style={{ width: '25rem' }} onHide={() => {if (!visible) return; handleCloseModal(); }} className='bg-white '>
//             <div className='flex flex-col items-center'>
//             <div className='flex justify-center items-center h-20 w-20 rounded-full border-4  border-[#00c1a0]'><i className='pi pi-check text-2xl text-[#00c1a0] font-bold'></i></div>
//             <br/>
//     <p className='text-black text-3xl font-bold text-center'>Please Click on Conmfirm Button to Subscribe</p>
//     <br/>
//     <p className='text-gray-500 text-sm text-center'>Your Pack Will be automatically Renewed. You can unsubscribe any time from profile Section.</p>
    
//     </div>
//             </div>
//         </div>
//     )



//   return (
//     <div>
//     <h2>Please Click on Conmfirm Button to Subscribe</h2>
//     <p>Your Pack Will be automatically Renewed. You can unsubscribe any time from profile Section.</p>
//     <div>
//     <button>Cancel</button>
//         <button>Confirm</button>
        
//     </div>
//     </div>
//   )
// }

// export default ConfirmationModal


















import React from "react";
import classes from "./ConfirmationModal.module.css";
// import { IoIosWarning } from "react-icons/io";
// import { useNavigate } from "react-router-dom";

const ConfirmationModal = ({subscribeLoading,visible,handleCloseModal,getSubData}) => {

    
        

  return (
    <>



    <div className="card flex justify-content-center">
             {/* <Button label="Show" icon="pi pi-external-link" onClick={() => setVisible(true)} /> */}
           
           
         </div>





    <div className={`${visible ? `${classes.modal_container} ${classes.modal_show}` : classes.modal_container}`}>
      <div className={classes.modal_sub_container}>
        
      <div  style={{ width: '25rem' }} onHide={() => {if (!visible) return; handleCloseModal(); }} className='bg-white '>
             <div className='flex flex-col items-center'>
             <div className='flex justify-center items-center h-20 w-20 rounded-full border-4  border-[#00c1a0]'><i className='pi pi-check text-2xl text-[#00c1a0] font-bold'></i></div>
             <br/>
     <p className='text-black text-3xl font-bold text-center'>Please Click on Confirm Button to Subscribe</p>
     <br/>
     <p className='text-gray-500 text-sm text-center'>Your Pack Will be automatically Renewed. You can unsubscribe any time from profile Section.</p>
    
     </div>
             </div>
             <form className='flex gap-2 justify-center' onSubmit={getSubData}>
         <button  className='p-2  text-white text-lg font-bold bg-[#495057] rounded-md px-4' onClick={()=>handleCloseModal()}>Cancel</button>
         <button  id="cta_button"
            type="submit" className='p-2 text-white text-lg font-bold bg-[#00c9a7] rounded-md px-4' >{subscribeLoading ? 'loading....' : 'Confirm' }</button>    
         </form>
      </div>
    </div>
    </>
  );
};

export default ConfirmationModal;



